import { isCenterWithin, parseFPTI } from './trackingUtils';

export enum TRACKING {
  PS_CLICK = 'data-cwt-ps-cl',
  PS_IMPRESSION = 'data-cwt-ps-im',
  PS_PRESENTMENT = 'data-cwt-ps-pr',
  FPTI_CLICK = 'data-cwt-fpti-cl',
  FPTI_IMPRESSION = 'data-cwt-fpti-im',
  FPTI_LOAD = 'data-cwt-fpti-av',
  FPTI_BASE = 'data-cwt-fpti-base',
  IMPRESSION_EVENT = 'data-cwt-im-event',
  IMPRESSION_VIEWPORT = 'data-cwt-im-viewport',
  IMPRESSION_VIEWPORT_INITIALIZED = 'data-cwt-im-viewport-init',
  IMPRESSION_REIMPRESS_EVENT = 'data-cwt-im-reimpress',
  IMPRESSION_OFF = 'data-cwt-im-off',
  LOAD_OFF = 'data-cwt-load-off',
}

export function getImpressionViewport(elem) {
  const selector = elem.getAttribute(TRACKING.IMPRESSION_VIEWPORT);
  if (selector) {
    return elem.querySelector(selector) || elem;
  }
  return elem;
}

export function findImpressionViewport(elem) {
  const viewportElem = closestWithAttribute(elem, TRACKING.IMPRESSION_VIEWPORT);
  if (viewportElem) {
    return getImpressionViewport(viewportElem);
  }
  return null;
}

export function isInViewport(elem) {
  const viewport = findImpressionViewport(elem);
  const vpBox = viewport ? viewport.getBoundingClientRect() : null;
  const elemBox = elem.getBoundingClientRect();

  if (
    !isCenterWithin(elemBox, {
      x: 0,
      y: 0,
      width: document.body.clientWidth,
      height: document.body.clientHeight,
      right: document.body.clientWidth,
      bottom: document.body.clientHeight,
    })
  ) {
    return false;
  }
  if (vpBox && !isCenterWithin(elemBox, vpBox)) {
    return false;
  }
  return true;
}

export function isImpressionEnabled(elem) {
  return !closestWithAttribute(elem, TRACKING.IMPRESSION_OFF);
}

export function isLoadEnabled(elem) {
  return !closestWithAttribute(elem, TRACKING.LOAD_OFF);
}

export function isDisplayed(elem) {
  if ((elem as HTMLElement).offsetParent) {
    return true;
  }
  const style = getComputedStyle(elem);
  return style.position === 'fixed' && style.display !== 'none';
}

export function getPSImpression(elem) {
  return elem.getAttribute(TRACKING.PS_IMPRESSION);
}

export function getFPTIImpression(elem) {
  return elem.getAttribute(TRACKING.FPTI_IMPRESSION);
}

export function elementsWithAttribute(attr, elem = null) {
  const list = Array.isArray(attr) ? attr : [attr];
  return (elem || document).querySelectorAll(list.map((a) => `[${a}]`).join(','));
}

export function closestWithAttribute(elem, attr) {
  return elem.closest(`[${attr}]`);
}

export function getPSURL(elem, attrib) {
  const trackingElem = closestWithAttribute(elem, attrib);
  if (trackingElem) {
    return trackingElem.getAttribute(attrib);
  }
  return '';
}

export function getFPTIBase(elem) {
  const allProps = [];
  let trackingElem = elem;
  while (trackingElem) {
    trackingElem = closestWithAttribute(trackingElem, TRACKING.FPTI_BASE);
    if (!trackingElem) {
      break;
    }
    allProps.push(parseFPTI(trackingElem.getAttribute(TRACKING.FPTI_BASE)));
    trackingElem = trackingElem.parentNode;
  }
  allProps.reverse();
  return allProps.reduce((mergedProps, props) => {
    return { ...mergedProps, ...props };
  }, {});
}

export function getFPTIProps(elem, attrib, props = {}) {
  const base = getFPTIBase(elem);
  const fpti = attrib ? parseFPTI(elem.getAttribute(attrib)) : {};
  return { ...base, ...fpti, ...props };
}
